import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/3d-game/standout-game.webp";
import { Link } from "gatsby";

function Elevategame() {
  return (
    <section
      className="ready_unity_game elevate_game standout_game text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Container className="h-100">
        <Row className="align-items-center h-100">
          <Col xs={12} md={10} lg={6} xl={6} xxl={5}>
            <h2>How can you create a standout 3D game for mobile platforms?</h2>
            <p>
              With TekRevol's expertise in 3D game development, we bring your
              vision to life with innovation and technical precision.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Elevate Your Game Now
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Elevategame;
